export default "__VITE_ASSET__egaIr4so__"